import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouteReplayResponse } from '../../../models/route-replay-response.model';
import { IMG_CONSTANTS } from 'src/app/route-replay/constants/img-constants';

@Component({
  selector: 'app-route-details',
  templateUrl: './route-details.component.html',
  styleUrl: './route-details.component.scss'
})
export class RouteDetailsComponent {
  @Input() routeData: RouteReplayResponse | null = null;
  @Input() routeName: string = '';
  
  @Output() backClick = new EventEmitter<void>();
  readonly imgConstants = IMG_CONSTANTS;

  onBackClick(): void {
    this.backClick.emit();
  }


getEmployeeStats() {
  if (!this.routeData) return [];

  return [
    { icon: this.imgConstants.PLANNED, count: this.routeData.plannedEmployees },
    { icon: this.imgConstants.SIGNIN, count: this.routeData.signedInEmployees },
    { icon: this.imgConstants.NO_SHOW, count: this.routeData.noShowEmployees }
  ];
}
}
